import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAddRewardSettingsMutation } from "../../redux/rewardSettingsApi";
import { useGetCryptocurrencyQuery } from "../../redux/cryptocurrencyApi";

import { useTranslation } from "react-i18next";

function AddRewardSettings({ show, onHide }) {
    const { t } = useTranslation();
    const [addData, setAddData] = useState({ status: "enabled" });
    const [addRewardSettings] = useAddRewardSettingsMutation();
    const { data: cryptoResponse } = useGetCryptocurrencyQuery();

    const cryptocurrencies = cryptoResponse?.data || [];

    const handleAddSave = async () => {
        if (!addData.reward_coin_id || !addData.reward_amount || !addData.status) {
            toast.error("Cryptocurrency, Amount, and Status are required!");
            return;
        }
        try {
            const response = await addRewardSettings(addData).unwrap();
            if (response.status) {
                toast.success(response.message || "Reward settings added successfully!");
                onHide();
                setAddData({ status: "enabled" });
            } else {
                toast.error(response.message || "Failed to add reward settings");
            }
        } catch (error) {
            toast.error("Error adding reward settings");
            console.error("Error adding reward settings:", error);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('add_reward_settings')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('cryptocurrency')}</Form.Label>
                        <Form.Select
                            value={addData.reward_coin_id || ""}
                            onChange={(e) => setAddData({ ...addData, reward_coin_id: e.target.value })}
                        >
                            <option value="">{t('select_cryptocurrency')}</option>
                            {cryptocurrencies.map((crypto, index) => (
                                <option key={index} value={crypto.id}>
                                    {crypto.coin_name} ({crypto.symbol})
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('amount')}</Form.Label>
                        <Form.Control
                            type="number"
                            step="any"
                            placeholder={t('enter_amount')}
                            value={addData.reward_amount || ""}
                            onChange={(e) => setAddData({ ...addData, reward_amount: e.target.value })}
                        />
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>{t('status')}</Form.Label>
                        <Form.Select
                            value={addData.status || "enabled"}
                            onChange={(e) => setAddData({ ...addData, status: e.target.value })}
                        >
                            <option value="enabled">{t('enabled')}</option>
                            <option value="disabled">{t('disabled')}</option>
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleAddSave}>
                    {t('add_reward_settings')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddRewardSettings;
